import { render } from "./AiInterpModal.vue?vue&type=template&id=04f3755e&scoped=true&ts=true"
import script from "./AiInterpModal.vue?vue&type=script&lang=ts"
export * from "./AiInterpModal.vue?vue&type=script&lang=ts"

import "./AiInterpModal.vue?vue&type=style&index=0&id=04f3755e&lang=less&scoped=true"
import "./AiInterpModal.vue?vue&type=style&index=1&id=04f3755e&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f3755e"]])

export default __exports__